<template>
  <div
    v-show="visible"
    class="m-popupVoucher-warp"
  >
    <div
      class="m-popupVoucher"
      :class="{
        vouchers: count > 1,
        'no-title': !data.showTitle
      }"
    >
      <img
        v-if="data.image"
        class="voucher-top-banner"
        :src="data.image"
      >
      <div
        class="m-popupVoucher--inner"
        :style="{
          background: hexColors[0]
        }"
      >
        <!-- note -->
        <div
          v-if="data.showTitle"
          class="push-vouchers-title"
        >
          {{ showSubTitle }}
        </div>

        <div
          v-if="data.mainImage"
          class="push-vouchers-mainImage"
        >
          <img :src="data.mainImage">
        </div>

        <template v-else>
          <!-- voucher item -->
          <SingleVoucher
            v-if="count === 1"
            :data="data.vouchers[0]"
          />

          <div
            v-else
            class="popupVoucher-voucherList"
          >
            <VoucherItem
              v-for="item in data.vouchers"
              :key="item.id"
              :data="item"
              :hex="hexColors[0]"
              @closeVoucher="closeVoucher"
              @openApp="openApp"
            />
          </div>
        </template>

        <div
          :class="['popupVoucher-footer',{
            'popupVoucher-footer20': count === 1
          }]"
        >
          <!-- button -->
          <div
            v-if="count === 1"
            class="popupVoucher-btn"
            :style="{
              background: hexColors[1]
            }"
            @click="useVoucher"
          >
            {{ buttonText }}
          </div>

          <div
            v-if="count > 1"
            class="push-vouchers-tips"
            :style="{
              background: hexColors[0]
            }"
          >
            {{ count }} Vouchers valued {{ $t('CURRENCY') }} {{ data.total }}
          </div>
        </div>

        <!-- close -->
        <div
          class="popupVoucher-close"
          @click="closeVoucher"
        >
          <svg-icon icon-class="icon-close" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 推送红包弹窗
 */
import { prefixLink } from '@ms/config/app'
import { dialogDownloadApp } from '@ms/utils/app/download.js'
import VoucherItem from './pagelet/VoucherItem'
import SingleVoucher from './pagelet/SingleVoucher'
import VDialog from 'fe-vui/dialog'
import { tryOpenApp } from 'wap/hybrid'
import { gotoUseVoucher } from '@ms/components/userPush/vouchers'
import modalHelper from '@ms/utils/scroll-fixed'
import 'base/icons/svg/close.svg'

export default {
  name: 'PopupVoucher',
  components: {
    VoucherItem,
    SingleVoucher
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    count() {
      const { vouchers, mainImage } = this.data
      return mainImage ? 1 : vouchers.length
    },
    buttonText() {
      const { vouchers, mainImage, buttonText } = this.data
      if (mainImage) {
        return buttonText || 'CHECK DETAIL'
      } else {
        return vouchers[0].status === 1 ? 'USE' : 'CHECK DETAILS'
      }
    },
    showSubTitle() {
      const { mainImage } = this.data
      if (this.count > 1 || mainImage) {
        return this.data.planName
      } else {
        return this.data.vouchers && this.data.vouchers[0] ? this.data.vouchers[0].title : ''
      }
    },
    hexColors() {
      const { hex } = this.data
      if (!hex) return []
      if (hex[0] === '[') {
        return JSON.parse(this.data.hex)
      } else {
        return [hex]
      }
    }
  },
  methods: {
    useVoucher() {
      if (this.data.closeOnUse) {
        this.closeVoucher()
        return false
      }
      if (this.data.vouchers[0] && this.data.vouchers[0].status === 1 && !this.data.mainImage) {
        if (this.data.vouchers[0].platform && this.data.vouchers[0].platform.toLowerCase() === 'android') {
          this.closeVoucher()
          this.openApp(this.data.vouchers[0].amount)
        } else {
          if (/\/sports\/list/i.test(location.pathname)) {
            this.closeVoucher()
          } else {
            const bizType = this.data.bizType || []
            gotoUseVoucher(bizType)
          }
        }
      } else {
        location.href = prefixLink('/vouchers')
      }
    },
    openApp(amount) {
      tryOpenApp('/params', {
        onfailed: () => dialogDownloadApp(`This voucher can be used on MSport app only. Download free app to get  ${this.$t('CURRENCY')} ${amount} OFF now.`),
        force: true
      })
    },
    closeVoucher() {
      this.$emit('voucherShow', false)
      modalHelper.beforeClose()
      VDialog.close()
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-popupVoucher-warp {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;

  .m-popupVoucher {
    position: relative;
    z-index: 999;
    top: 50%;
    left: 50%;
    width: 270px;
    box-sizing: border-box;
    border-radius: 4px;
    letter-spacing: 0;
    text-align: center;
    transform: translate(-50%, -50%);

    .m-popupVoucher--inner {
      background: #585874;
    }

    &.no-title {
      .m-popupVoucher--inner {
        padding-top: 15/@rem;
      }
    }
  }

  .voucher-top-banner {
    display: block;
    width: 100%;
  }

  .popupVoucher-close {
    position: absolute;
    bottom: -19.7/@rem;
    left: 50%;
    display: flex;
    width: 36/@rem;
    height: 36/@rem;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #222;
    transform: translate(-50%, 100%);

    .svg-icon {
      color: #999;
      font-size: 24/@rem;
    }
  }

  .vouchers {
    width: 272/@rem;
    height: auto;

    .push-vouchers-title {
      height: 30/@rem;
      padding-top: 0;
      line-height: 30/@rem;
    }

    .popupVoucher-voucherList {
      padding: 0;
    }
  }

  .push-vouchers-tips {
    position: absolute;
    z-index: 10;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 30/@rem;
    background: #585874;
    color: #fff;
    font-size: 10/@rem;
    line-height: 30/@rem;
    text-align: center;
    // box-shadow: 0 -2px 6px 0 rgba(0,0,0,0.50);
  }

  .push-vouchers-title {
    width: 100%;
    padding-top: 9/@rem;
    color: #fff;
    font-size: 16/@rem;
    font-style: italic;
    font-weight: 600;
    text-align: center;
  }

  .push-vouchers-mainImage {
    display: grid;
    overflow: scroll;
    width: 240/@rem;
    height: 222/@rem;
    margin: 9/@rem auto 0;

    > img {
      width: 100%;
      margin: auto;
    }
  }

  .popupVoucher-voucherList {
    width: 268/@rem;
    max-height: 219/@rem;
    margin: 0 auto;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .popupVoucher-voucherList::-webkit-scrollbar {
    width: 2px;
    height: 1px;
  }

  .popupVoucher-voucherList::-webkit-scrollbar-thumb {
    border-radius: 1px;
    background: rgba(256, 256, 256, 40%);
  }

  .popupVoucher-voucherList::-webkit-scrollbar-track {
    background: transparent;
  }

  .popupVoucher-footer {
    position: relative;
    padding: 15/@rem 0;
    box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 50%);

    &.popupVoucher-footer20 {
      padding: 20/@rem 0;
    }
  }

  .popupVoucher-btn {
    min-width: 110/@rem;
    max-width: 150/@rem;
    height: 33/@rem;
    border-radius: 16.5/@rem;
    margin: 0 auto;
    background: #38212a;
    color: #333;
    font-size: 14/@rem;
    line-height: 33/@rem;
    text-align: center;
  }

  .popupVoucher-btn:active {
    background: #b28d1b;
    color: #333;
  }
}

.item-platform {
  position: absolute;
  top: -1px;
  left: -1px;
  width: 50/@rem;
  height: 14/@rem;
  box-sizing: border-box;
  border-radius: 0 0 10/@rem 0;
  background: #e51717;
  color: @white;
  font-size: 10px;
  font-weight: 300;
  line-height: 15px;
  text-align: center;
}
</style>
